import styled from "styled-components";
import { Box } from "rebass/styled-components";

const Row = styled(Box)<{
  width?: string;
  align?: string;
  justify?: string;
  padding?: string;
  border?: string;
  borderRadius?: string;
  gap?: string;
}>`
  width: ${({ width }) => width ?? "100%"};
  display: flex;
  padding: 0;
  align-items: ${({ align }) => align ?? "center"};
  justify-content: ${({ justify }) => justify ?? "flex-start"};
  padding: ${({ padding }) => padding};
  border: ${({ border }) => border};
  border-radius: ${({ borderRadius }) => borderRadius};
  gap: ${({ gap }) => gap};
`;

export const RowBetween = styled(Row)`
  justify-content: space-between;
`;

export const RowFlat = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const AutoRow = styled(Row)<{ gap?: string; justify?: string }>`
  flex-wrap: wrap;
  margin: ${({ gap }) => gap && `-${gap}`};
  justify-content: ${({ justify }) => justify && justify};

  & > * {
    margin: ${({ gap }) => gap} !important;
  }
`;

export const RowFixed = styled(Row)<{ gap?: string; justify?: string }>`
  width: fit-content;
  margin: ${({ gap }) => gap && `-${gap}`};
`;

export const ResponsiveRow = styled(RowBetween)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    row-gap: 1rem;
  `};
`;
export const ResponsiveRowWrap = styled(Row)<{ minWidth?: number }>`
  display: grid;
  grid-template-columns: ${({ minWidth }) =>
    `repeat(auto-fit, minmax(${minWidth ?? 350}px, 1fr))`};
  gap: 1rem;
`;
export const ResponsiveRowWrap2 = styled(Row)`
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
  @media (min-width: 45em) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 55em) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export default Row;
